import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './page/home/home.component';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SwiperModule } from 'swiper/angular';
import { MaterialModule } from '../material/material.module';
import { SharedModule } from '../shared/shared.module';
import { Covid19Component } from './component/covid19/covid19.component';
import { DiagnosisDaysComponent } from './component/diagnosis-days/diagnosis-days.component';
import { MainvisualComponent } from './component/mainvisual/mainvisual.component';
import { BeginnersComponent } from './component/beginners/beginners.component';
import { IntroductionComponent } from './component/introduction/introduction.component';
import { FeedbackComponent } from './component/feedback/feedback.component';
import { RelationComponent } from './component/relation/relation.component';

@NgModule({
  declarations: [
    HomeComponent,
    Covid19Component,
    DiagnosisDaysComponent,
    MainvisualComponent,
    BeginnersComponent,
    IntroductionComponent,
    FeedbackComponent,
    RelationComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    FormsModule,
    FlexLayoutModule,
    SwiperModule,
    MaterialModule,
    SharedModule,
  ],
})
export class HomeModule { }
